import Request from './Request';
import Api from './Api';

const productFertilizerService = {

  async getAll(companyId) {
    const xhr = await Request.async(`${Api.getBaseUrl()}/product/all`,
      { data: {} }, 'GET',
      false, 'application/json', Api.getHeaderAuth(),
      companyId);
    return JSON.parse(xhr.response);
  },
  async getById(id) {
    const xhr = await Request.async(`${Api.getBaseUrl()}/product/${id}`,
      { data: {} }, 'GET',
      false, 'application/json',
      Api.getHeaderAuth());
    return JSON.parse(xhr.response);
  },
};

export default productFertilizerService;
